import React, { useState } from "react";
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TablePagination, Select, MenuItem
} from "@mui/material";
import { CheckCircle, Cancel, AccessTime } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";

const MS_COLORS = {
  primary: "#2D4A3D",
  primaryLight: "#EBF5EE",
  text: "#323130",
  textSecondary: "#605D5C",
  background: "#FFFFFF",
  backgroundLight: "#F3F2F1",
  border: "#E1E1E1",
  hoverBackground: "#F0F0F0",
  white: "#FFFFFF",
  accent: "#107C10",
};

const TransactionsManagement = ({ transactions }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [statusFilter, setStatusFilter] = useState("all");

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterChange = (event) => setStatusFilter(event.target.value);

  const filteredTransactions =
    statusFilter === "all"
      ? transactions
      : transactions.filter((transaction) => transaction.status === statusFilter);

  return (
    <Box sx={{ backgroundColor: "#fff", borderRadius: "16px", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.05)", p: 3, mt: 3 }}>
      <Box mb={2} display="flex" justifyContent="flex-end">
        <Select
          value={statusFilter}
          onChange={handleFilterChange}
          size="small"
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="all">All Transactions</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Completed">Completed</MenuItem>
          <MenuItem value="Failed">Failed</MenuItem>
          <MenuItem value="Processed">Processed</MenuItem>
        </Select>
      </Box>

      {filteredTransactions.length === 0 ? (
        <Box sx={{ textAlign: "center", color: MS_COLORS.textSecondary, mt: 2, mb: 2, p: 3, border: `1px dashed ${MS_COLORS.border}`, borderRadius: 1, bgcolor: MS_COLORS.backgroundLight }}>
          <FontAwesomeIcon icon={faBoxOpen} size="2x" style={{ marginBottom: "10px" }} />
          <Typography variant="body2">No transactions found matching the selected filter.</Typography>
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 1, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", overflowX: "auto", border: `1px solid ${MS_COLORS.border}` }}>
          <Table sx={{ minWidth: 700 }}>
            <TableHead sx={{ bgcolor: MS_COLORS.backgroundLight }}>
              <TableRow>
                {["User Name", "Transaction Type", "Amount (UGX)", "Fundraise", "Status"].map((header) => (
                  <TableCell key={header} sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", color: MS_COLORS.text }}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTransactions
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((transaction) => (
                  <TableRow key={transaction.id} sx={{ "&:hover": { backgroundColor: MS_COLORS.hoverBackground } }}>
                    <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary }}>{transaction.user}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary }}>{transaction.type}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary }}>
                      UGX {transaction.amount.toLocaleString()}
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary }}>{transaction.fundraise}</TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1} sx={{ color: transaction.status === "Completed" ? MS_COLORS.accent : transaction.status === "Pending" ? "orange" : "red" }}>
                        {transaction.status === "Completed" ? <CheckCircle fontSize="small" /> : transaction.status === "Pending" ? <AccessTime fontSize="small" /> : <Cancel fontSize="small" />}
                        <Typography variant="body2">{transaction.status}</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {filteredTransactions.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredTransactions.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Box>
  );
};

export default TransactionsManagement;
